jQuery.cookie=function(_1,_2,_3){
if(typeof _2!="undefined"){
_3=_3||{};
if(_2===null){
_2="";
_3.expires=-1;
}
var _4="";
if(_3.expires&&(typeof _3.expires=="number"||_3.expires.toUTCString)){
var _5;
if(typeof _3.expires=="number"){
_5=new Date();
_5.setTime(_5.getTime()+(_3.expires*24*60*60*1000));
}else{
_5=_3.expires;
}
_4="; expires="+_5.toUTCString();
}
var _6=_3.path?"; path="+(_3.path):"";
var _7=_3.domain?"; domain="+(_3.domain):"";
var _8=_3.secure?"; secure":"";
document.cookie=[_1,"=",encodeURIComponent(_2),_4,_6,_7,_8].join("");
}else{
var _9=null;
if(document.cookie&&document.cookie!=""){
var _a=document.cookie.split(";");
for(var i=0;i<_a.length;i++){
var _b=jQuery.trim(_a[i]);
if(_b.substring(0,_1.length+1)==(_1+"=")){
_9=decodeURIComponent(_b.substring(_1.length+1));
break;
}
}
}
return _9;
}
};


(function($){$.toJSON=function(o)
{if(typeof(JSON)=='object'&&JSON.stringify)
return JSON.stringify(o);var type=typeof(o);if(o===null)
return"null";if(type=="undefined")
return undefined;if(type=="number"||type=="boolean")
return o+"";if(type=="string")
return $.quoteString(o);if(type=='object')
{if(typeof o.toJSON=="function")
return $.toJSON(o.toJSON());if(o.constructor===Date)
{var month=o.getUTCMonth()+1;if(month<10)month='0'+month;var day=o.getUTCDate();if(day<10)day='0'+day;var year=o.getUTCFullYear();var hours=o.getUTCHours();if(hours<10)hours='0'+hours;var minutes=o.getUTCMinutes();if(minutes<10)minutes='0'+minutes;var seconds=o.getUTCSeconds();if(seconds<10)seconds='0'+seconds;var milli=o.getUTCMilliseconds();if(milli<100)milli='0'+milli;if(milli<10)milli='0'+milli;return'"'+year+'-'+month+'-'+day+'T'+
hours+':'+minutes+':'+seconds+'.'+milli+'Z"';}
if(o.constructor===Array)
{var ret=[];for(var i=0;i<o.length;i++)
ret.push($.toJSON(o[i])||"null");return"["+ret.join(",")+"]";}
var pairs=[];for(var k in o){var name;var type=typeof k;if(type=="number")
name='"'+k+'"';else if(type=="string")
name=$.quoteString(k);else
continue;if(typeof o[k]=="function")
continue;var val=$.toJSON(o[k]);pairs.push(name+":"+val);}
return"{"+pairs.join(", ")+"}";}};$.evalJSON=function(src)
{if(typeof(JSON)=='object'&&JSON.parse)
return JSON.parse(src);return eval("("+src+")");};$.secureEvalJSON=function(src)
{if(typeof(JSON)=='object'&&JSON.parse)
return JSON.parse(src);var filtered=src;filtered=filtered.replace(/\\["\\\/bfnrtu]/g,'@');filtered=filtered.replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,']');filtered=filtered.replace(/(?:^|:|,)(?:\s*\[)+/g,'');if(/^[\],:{}\s]*$/.test(filtered))
return eval("("+src+")");else
throw new SyntaxError("Error parsing JSON, source is not valid.");};$.quoteString=function(string)
{if(string.match(_escapeable))
{return'"'+string.replace(_escapeable,function(a)
{var c=_meta[a];if(typeof c==='string')return c;c=a.charCodeAt();return'\\u00'+Math.floor(c/16).toString(16)+(c%16).toString(16);})+'"';}
return'"'+string+'"';};var _escapeable=/["\\\x00-\x1f\x7f-\x9f]/g;var _meta={'\b':'\\b','\t':'\\t','\n':'\\n','\f':'\\f','\r':'\\r','"':'\\"','\\':'\\\\'};})(jQuery);personified=function(){
var _1="conciergify.personified";
attributes=function(_2){
var _3=_hydrate();
if(typeof (_2)!="undefined"){
var _4=[];
for(var n=0;n<_3.length;n++){
if(_3[n].variant==_2){
_4.push(_3[n]);
}
}
_3=_4;
}
return _3;
};
enumerate=function(_5){
var _6=personified.attributes();
for(var n=0;n<_6.length;n++){
if(_5(_6[n].variant,_6[n].values,n)==false){
break;
}
}
};
values=function(_7,_8){
var _9;
var _a=typeof (_8)=="undefined"?1:_8;
var _b=0;
enumerate(function(v,_c){
if(v==_7){
_b++;
if(_b==_a){
_9=_c;
return false;
}
}
});
return _9;
};
variants=function(){
var _d=[];
enumerate(function(v,_e){
if(jQuery.inArray(v,_d)==-1){
_d.push(v);
}
});
return _d;
};
save=function(_f,_10){
var _11=_form(_f);
var _12=jQuery.extend(new Object(),_10);
_11.find(".personified").each(function(ndx,_13){
if(!$(this).attr("disabled")){
_12[$(this).attr("id")]=$(this).val();
}
});
var _14=_11.find("select[name=id]").val()||_11.find("input[name=id]").val();
if(typeof (_14)=="undefined"){
alert("Can't find variant id");
return;
}
var _15=this.attributes(_14);
var ts=new Date().getTime();
var qty=_11.find("select[name=qty]").val()||_11.find("select[name=quantity]").val()||1;
for(var i=0;i<qty;i++){
_15.push({variant:_14,values:_12,ts:ts});
}
_persist(_14,_15);
};
restore=function(_16,_17){
var _18=_form(_16);
var _19=_19(_17);
if(typeof (_19)=="undefined"){
return;
}
for(field in Personified.fields){
_18.find("#"+field).val(_19[field]);
}
};
remove=function(ts){
var all=personified.attributes();
for(var n=0;n<all.length;n++){
if(all[n].ts==ts){
var _1a=all[n].variant;
var _1b=personified.attributes(_1a);
_1b.splice(0,1);
_persist(_1a,_1b);
return true;
}
}
return false;
};
clear=function(){
jQuery.each(_control(),function(ndx,_1c){
jQuery.cookie(_1c,null,{path:"/"});
});
jQuery.cookie(_1,null,{path:"/"});
};
_control=function(){
var _1d=jQuery.cookie(_1);
return _1d?jQuery.evalJSON(_1d):[];
};
_persist=function(_1e,_1f){
var _20=_control();
var _21=_1+"."+_1e;
if(_1f.length==0){
jQuery.cookie(_21,null,{path:"/"});
for(var n=0;n<_20.length;n++){
if(_20[n]==_21){
_20.splice(n,1);
}
}
}else{
jQuery.cookie(_21,jQuery.toJSON(_1f),{path:"/",expires:14});
if(jQuery.inArray(_21,_20)==-1){
_20.push(_21);
}
}
jQuery.cookie(_1,jQuery.toJSON(_20),{path:"/",expires:14});
};
_hydrate=function(){
var _22=jQuery.cookie(_1);
var _23=_22?jQuery.evalJSON(_22):[];
var _24=[];
for(var i=0;i<_23.length;i++){
var _25=jQuery.cookie(_23[i]);
_24=jQuery.merge(_24,jQuery.evalJSON(_25));
}
return _24;
};
_nullsafe=function(_26){
return _26?_26:"";
};
_form=function(_27){
var _28=(typeof (_27)=="string")?jQuery("#"+_27):jQuery(_27);
if(_28.size()==0){
alert("Invalid form id");
}
return _28;
};
return {enumerate:enumerate,attributes:attributes,values:values,variants:variants,save:save,remove:remove,clear:clear};
}();

